import { render, staticRenderFns } from "./AveragePurchasePrice.vue?vue&type=template&id=18c916a8&scoped=true"
import script from "./AveragePurchasePrice.vue?vue&type=script&lang=js"
export * from "./AveragePurchasePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c916a8",
  null
  
)

export default component.exports